import { render, staticRenderFns } from "./FieldBadgeAssociation.vue?vue&type=template&id=256573d9&scoped=true"
import script from "./FieldBadgeAssociation.vue?vue&type=script&lang=js"
export * from "./FieldBadgeAssociation.vue?vue&type=script&lang=js"
import style0 from "./FieldBadgeAssociation.vue?vue&type=style&index=0&id=256573d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256573d9",
  null
  
)

export default component.exports